module.exports = __webpack_public_path__ + "mer/img/404.a57b6f31.png";